import {
  Skeleton as MUISkeleton,
  SkeletonProps as MUISkeletonProps,
} from '@mui/material';

type AtomMUIProps = {
  /**
   * Width of the skeleton relative to container
   * @default '100%'
   */
  width?: string;
  variant?: 'text' | 'rectangular' | 'circular';
};

export type SkeletonProps = AtomMUIProps;

export const Skeleton = (props: SkeletonProps) => {
  const { width = '100%', ...data } = props;

  const MUIProps: MUISkeletonProps = data;

  return <MUISkeleton width={width} {...MUIProps} />;
};

export default Skeleton;
